<footer class="c-foundation-cdn-footer" id="features">
	<div class="container">
		<h2>OUR CDN FEATURES:</h2>
		<div class="row">
			<div class="col-md-1 hidden-xs hidden-sm"></div>

			<div class="col-xs-6 col-sm-4 col-md-2">
				<img width="150" height="88" src="{{@shared.assetsHost}}/img/foundation-cdn/multicdn.png" loading="lazy"/>
				<h3>FREE MULTI-CDN</h3>
			</div>

			<div class="col-xs-6 col-sm-4 col-md-2">
				<img width="150" height="88" src="{{@shared.assetsHost}}/img/foundation-cdn/load-balancing.png" loading="lazy"/>
				<h3>LOAD BALANCING</h3>
			</div>

			<div class="col-xs-6 col-sm-4 col-md-2">
				<img width="150" height="88" src="{{@shared.assetsHost}}/img/foundation-cdn/api.png" loading="lazy"/>
				<h3>A REAL API</h3>
			</div>

			<div class="col-xs-6 col-sm-4 col-md-2 col-sm-push-2 col-md-push-0">
				<img width="150" height="88" src="{{@shared.assetsHost}}/img/foundation-cdn/combinefiles.png" loading="lazy"/>
				<h3>COMBINE FILES</h3>
			</div>

			<div class="col-xs-6 col-sm-4 col-md-2 col-xs-push-3 col-sm-push-2 col-md-push-0">
				<img width="150" height="88" src="{{@shared.assetsHost}}/img/foundation-cdn/autoupdates.png" loading="lazy"/>
				<h3>AUTOMATIC UPDATES</h3>
			</div>
		</div>

		<a class="button" href="/" target="_blank">
			<i class="fa fa-eye"></i> See All Features
		</a>
	</div>
</footer>
